import { EBEPaymentMethodsName, EPaymentProvider, PaymentMethod } from '../contracts';

const paymentMethodNameToStripePaymentMethodTypesMap: Record<string, string[]> = {
  [EBEPaymentMethodsName.card]: [EBEPaymentMethodsName.card],
  [EBEPaymentMethodsName.blikCheckout]: [EBEPaymentMethodsName.card],
  // Native BLIK confirms via stripe.confirmBlikPayment and never mounts a
  // PaymentElement, but Elements still needs valid options to initialize.
  [EBEPaymentMethodsName.blik]: [EBEPaymentMethodsName.card],
  [EBEPaymentMethodsName.link]: [EBEPaymentMethodsName.card],
};

export function getStripePaymentMethodTypesFromApm(paymentMethod: PaymentMethod) {
  if (paymentMethod.provider !== EPaymentProvider.stripe) {
    return [];
  }
  const paymentMethodTypes =
    paymentMethodNameToStripePaymentMethodTypesMap[paymentMethod.paymentMethodName];

  return paymentMethodTypes || [paymentMethod.pspPaymentMethodName];
}
